/* eslint-disable */
import React, { useState } from "react";
import { connect } from "react-redux";
import { history } from "../../../config/stores";
import { getSubscribedUsersList } from "../../../actions";
import "./UserSearch.scss";

const UserSearch = ({ getSubscribedUsersList, freeUsers }) => {
  const [searchType, setSearchType] = useState("name"); // "name" or "email"
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const handleClose = () => {
    history.goBack();
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setSearchValue("");
    setSearchResults([]);
    setHasSearched(false);
  };

  const handleSearch = () => {
    if (!searchValue.trim()) return;
    
    setIsLoading(true);
    setHasSearched(true);
    
    // Prepare API payload based on search type
    const searchPayload = {
      type: "free", // Search all users regardless of subscription type
      name: searchType === "name" ? searchValue.trim() : "",
      email: searchType === "email" ? searchValue.trim() : "",
      registeredFrom: "",
      registeredTo: "",
      propertiesFrom: null,
      propertiesTo: null,
      walletsFrom: null,
      walletsTo: null,
      bankAccountsFrom: null,
      bankAccountsTo: null,
      page: 1,
      limit: 50, // Show more results for search
      onSuccess: (response) => {
        setIsLoading(false);
        const results = response?.payload?.docs || [];
        setSearchResults(results);
      },
      onError: (error) => {
        setIsLoading(false);
        console.error("Search error:", error);
        setSearchResults([]);
      }
    };

    getSubscribedUsersList(searchPayload);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="main-container">
      <div className="inner-header-container">
        <div className="left-part">
          <div className="close-icon" onClick={handleClose} />
          <div className="inner-title">USER SEARCH</div>
        </div>
      </div>
      
      <div className="body-container user-search-container">
        <div className="search-label">
          Search by*
        </div>
        
        <div className="search-type-buttons">
          <button
            className={`search-type-button ${searchType === "name" ? "selected" : ""}`}
            onClick={() => handleSearchTypeChange("name")}
          >
            USER'S NAME
          </button>
          <button
            className={`search-type-button ${searchType === "email" ? "selected" : ""}`}
            onClick={() => handleSearchTypeChange("email")}
          >
            E-MAIL
          </button>
        </div>
        
        <input
          type="text"
          className="search-input"
          placeholder={searchType === "name" ? "Enter user's name..." : "Enter user's email..."}
          value={searchValue}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        
        <button
          className="search-button"
          onClick={handleSearch}
          disabled={!searchValue.trim() || isLoading}
        >
          {isLoading ? "SEARCHING..." : "SEARCH"}
        </button>
        
        <div className="search-results">
          {searchResults.length > 0 && (
            <div className="results-container">
              <h3 className="results-title">Search Results ({searchResults.length})</h3>
              <div className="results-list">
                {searchResults.map((user, index) => (
                  <div key={user._id || index} className="user-result-row">
                    <div className="user-details">
                      <div className="user-name">{user.fullName || "Unknown User"}</div>
                      <div className="user-email">{user.email || "No email"}</div>
                      <div className="user-stats">
                        <span className="stat-item">Properties: {user.propertiesCount || 0}</span>
                        <span className="stat-item">Wallets: {user.walletsCount || 0}</span>
                        <span className="stat-item">Bank Accounts: {user.bankAccountsCount || 0}</span>
                      </div>
                      <div className="user-date">
                        Registered: {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : "Unknown"}
                      </div>
                    </div>
                    <div className="user-subscription">
                      <span className="subscription-badge">
                        {user.subscriptionType || "FREE"}
                      </span>
                      {user.subscriptionValidUntil && (
                        <div className="subscription-date">
                          Valid until: {new Date(user.subscriptionValidUntil).toLocaleDateString()}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {searchResults.length === 0 && hasSearched && !isLoading && (
            <div className="no-results">
              <p>No users found matching "{searchValue}"</p>
              <p className="search-tip">Try searching with a different {searchType === "name" ? "name" : "email address"}</p>
            </div>
          )}
          
          {!hasSearched && !isLoading && (
            <div className="no-search-yet">
              <p>Enter a {searchType === "name" ? "user's name" : "user's email"} and click SEARCH to find users</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  freeUsers: state.dashboard.freeUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribedUsersList: (payload) => dispatch(getSubscribedUsersList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSearch);
